import axios from 'axios';

const api = axios.create({
  baseURL: 'https://0o25gf1lxk.execute-api.us-west-2.amazonaws.com/dev/',
});

const apiTest = axios.create({
  baseURL: 'http://localhost:3000/dev/',
});

const apiProd = axios.create({
  baseURL: 'https://rs2z8s1arg.execute-api.us-east-2.amazonaws.com/prod/',
});

export { api, apiTest, apiProd };
